export var TwoFactorAuthType;
(function (TwoFactorAuthType) {
    TwoFactorAuthType["SMS"] = "sms";
    TwoFactorAuthType["GOOGLE"] = "google";
    TwoFactorAuthType["EMAIL"] = "email";
})(TwoFactorAuthType || (TwoFactorAuthType = {}));
//# sourceMappingURL=twoFactorAuth.js.map